import React from 'react';

import { Artwork as ArtworkCell } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, NoResults, Spaced, Title, forResource } from '../common/container/Container.jsx';
import { Label as FormLabel } from '../common/container/Form.jsx';
import { Fullscreen as LoadingFull, Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd, Popup } from '../common/container/Popup.jsx';
import { Artists as ArtistsSlider, Artwork as ArtworkSlider, Galleries as GalleriesSlider, Profiles as ProfilesSlider } from '../common/container/Slider.jsx';
import { Tab, Section } from '../common/container/Container.jsx';
import { Follow as FollowButton, Text as TextButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Select } from '../common/input/DropDown.jsx';
import { Input } from '../common/input/Text.jsx';

let _ProfileInst;
class _Profile extends React.Component {
    constructor(props) {
        super(props);

        let tab;
        const pathComponents = location.pathname.split('/');
        if (pathComponents && pathComponents.length > 0) {
            tab = pathComponents[pathComponents.length - 1];
        }
        if (tab == props.slug) {
            tab = 'profile';
        }

        this.state = {
            artwork: {
                dir: 1,
                limit: 20,
                loading: false,
                offset: 0,
                order: 2
            },
            collection: {
                dir: 1,
                limit: 20,
                loading: false,
                offset: 0,
                order: 2
            },
            lists: {
                loading: true
            },
        };

        if (tab == 'following') {
            this.galleriesSliderConfig = {
                items: 3,
                loop: true,
                margin: 20,
                nav: true,
                navText: ["", ""],
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                        slideBy: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 3,
                        slideBy: 3
                    }
                },
                rewindNav: true
            };
        }
        this.configureTabs = this.configureTabs.bind(this);
        this.getArtwork = this.getArtwork.bind(this);
        this.getCollection = this.getCollection.bind(this);
        this.getLists = this.getLists.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleArtworkWaypointEnter = this.handleArtworkWaypointEnter.bind(this);  
        this.handleCollectionWaypointEnter = this.handleCollectionWaypointEnter.bind(this);  
        this.handleEditAccount = this.handleEditAccount.bind(this);
        this.handleEditAccountClose = this.handleEditAccountClose.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleManageCollection = this.handleManageCollection.bind(this);
        this.handleParseFollows = this.handleParseFollows.bind(this);
    }

    componentDidMount() {
        _ProfileInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.profiles._isfollowing(responseData);

            responseData.User = Artcloud.auth.user;
            responseData.MyAccount = false;
            if (responseData.User && responseData.User.UserId === parseInt(component.props.slug, 10)) {
                responseData.MyAccount = true;
            }
            responseData.IsCollector = false;
            if (responseData.User && responseData.User.Type && responseData.User.Type.Value === 6) {
                responseData.IsCollector = true;
            }
            const id = responseData.ProfileId;
            component.getArtwork(id);
            component.getCollection(id);
            component.getLists(id);
            component.configureTabs();
        });
    }

    componentWillUnmount() {
        _ProfileInst = undefined;

        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
        if (this.collectionRequest) {
            this.collectionRequest.abort();
            this.collectionRequest = null;
        }
        if (this.listsRequest) {
            this.listsRequest.abort();
            this.listsRequest = null;
        }
    }

    configureTabs() {
        const tabs = [{ active: true, label: 'Profile', tab: 'profile' }];
        tabs.push({ label: 'Lists', tab: 'lists' });
        tabs.push({ label: 'Following', tab: 'following' });
        tabs.push({ label: 'Collection', tab: 'collection' });
    
        this.props.onConfigureTabs(tabs, 'profile');
    }

    getArtwork(profileId) {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.profiles.curated.get(profileId),
            { dir: state.dir, limit: state.limit, offset: state.offset, order: state.order },
            function (responseData) {
                component.artworkRequest = null;

                responseData.Art.forEach(function (d) {
                    Artcloud.mkt.art._isfavorite(d);
                });
                let data = state.data || [];
                state.data = data.concat(responseData.Art);

                state.offset += responseData.Art.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getCollection(profileId) {
        const component = this;
        const state = component.state.collection;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            collection: state
        });
        component.collectionRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.profiles.art.get(profileId),
            { dir: state.dir, limit: state.limit, offset: state.offset, order: state.order },
            function (responseData) {
                component.collectionRequest = null;

                let data = state.data || [];
                state.data = data.concat(responseData.Art);

                state.offset += responseData.Art.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    collection: state
                });
            },
            function (jqXHR, textStatus) {
                component.collectionRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    collection: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getLists(profileId) {
        const component = this;
        component.listsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.profiles.lists.get(profileId),
            null,
            function (responseData) {
                component.listsRequest = null;

                responseData.Lists.forEach(function (d) {
                    if (d.Image) {
                        d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, null, 1024);
                    }
                });
                component.setState({
                    lists: {
                        data: responseData.Lists,
                        total: responseData.Total
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.listsRequest = null;

                component.setState({
                    lists: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_ProfileInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleArtworkWaypointEnter() {
        if (
          !this.state.artwork.data ||
          (this.state.artwork.data &&
            this.state.artwork.offset >= this.state.artwork.total)
        ) {
          return;
        }
        this.getArtwork(this.props.data.ProfileId);
      }


    handleCollectionWaypointEnter() {
        if (
          !this.state.collection.data ||
          (this.state.collection.data &&
            this.state.collection.offset >= this.state.collection.total)
        ) {
          return;
        }
        this.getCollection(this.props.data.ProfileId);
      }

    handleEditAccount(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.data.IsCollector) {
            this.setState({
                accountModal: true
            });
        } else {
            Artcloud.auth.redirectToSettings();
        }
    }

    handleEditAccountClose() {
        this.setState({
            accountModal: undefined
        });
    }

    handleFollowChange() {
        const component = this;
        const data = this.props.data;
        Artcloud.mkt.galleries.updateFollowing(data.ProfileId, !data.IsFollowing, data.Name, function (success) {
            if (success != true) {
                return;
            }
            data.IsFollowing = !data.IsFollowing;
            component.props.onUpdateData(data);
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleManageCollection() {
        Artcloud.auth.redirectToInventory();
    }

    handleParseFollows(responseData) {
        if (responseData.Artists) {
            responseData.Artists.forEach(function (d) {
                Artcloud.mkt.artists._isfollowing(d);
            });
            this.setState({
                artistsFollowsTitle: `Following ${responseData.Total} artist${responseData.Total != 1 ? 's' : ''}`
            });
            return responseData.Artists;
        } else if (responseData.Galleries) {
            responseData.Galleries.forEach(function (d) {
                Artcloud.mkt.galleries._isfollowing(d);
            });
            if (this.galleriesSliderConfig && (responseData.Galleries.length <= this.galleriesSliderConfig.items)) {
                this.galleriesSliderConfig.nav = false;
            }
            this.setState({
                galleriesFollowsTitle: `Following ${responseData.Total} galler${responseData.Total != 1 ? 'ies' : 'y'}`
            });
            return responseData.Galleries;
        } else if (responseData.Profiles) {
            const data = [];
            let profiles;
            for (let i = 0; i < responseData.Profiles.length; i++) {
                if (!profiles) {
                    profiles = [responseData.Profiles[i]]
                } else {
                    profiles.push(responseData.Profiles[i]);
                    data.push({ profiles: profiles });
                    profiles = undefined;
                }
            }
            if (profiles) {
                data.push({ profiles: profiles });
            }
            this.setState({
                profilesFollowsTitle: `Following ${responseData.Total} profile${responseData.Total != 1 ? 's' : ''}`
            });
            return data;
        }
    }

    render() {
        if (!this.props.data) {
            return <LoadingIndicator />
        }
        const data = this.props.data;

        return (
            <React.Fragment>
                {
                    !this.props.data &&
                    <LoadingIndicator />
                }
                <ProfileHeader data={data} onEditAccount={this.handleEditAccount} onFollowChange={this.handleFollowChange} />
                <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
                <Section>
                    <Spaced className="tabs__content tabs__content__active spacer--bottom">
                        {
                            this.props.tab== 'profile' &&
                            <React.Fragment>
                                <Spaced className="spacer--bottom">
                                    <div className="container--spaced__row">
                                        <div className="grid grid--6">
                                            <Title small={true}>
                                                <h2>Bio</h2>
                                            </Title>
                                            <div className="bio__cont bio--outline">
                                                <div className="bio__cont__inner">
                                                    <div className="bio__item">
                                                        <span className="bio__item__label">Name</span>
                                                        <span className="bio__item__text">{data.Name}</span>
                                                    </div>
                                                    <div className="bio__item">
                                                        <span className="bio__item__label">Hometown</span>
                                                        {
                                                            data.Location &&
                                                            <span className="bio__item__text">{data.Location}</span>
                                                        }
                                                        {
                                                            !data.Location &&
                                                            <React.Fragment>
                                                                {
                                                                    data.MyAccount &&
                                                                    <span>
                                                                        <a href="#" onClick={this.handleEditAccount}>Add Hometown</a>
                                                                    </span>
                                                                }
                                                                {
                                                                    !data.MyAccount &&
                                                                    <span className="bio__item__text">-</span>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                    <div className="bio__item">
                                                        <span className="bio__item__label">Following</span>
                                                        {
                                                            data.Follows &&
                                                            <span className="bio__item__text">{data.Follows.Artists} artists &amp; {data.Follows.Galleries} galleries</span>
                                                        }
                                                    </div>
                                                    <div className="bio__item">
                                                        <span className="bio__item__label">Lists</span>
                                                        <span className="bio__item__text">{data.Lists} lists</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            data.ProfileId &&
                                            <ArtworkSlider
                                                className="grid grid--6"
                                                hideOnEmpty={true}
                                                id="recent"
                                                q={{ limit: 6, offset: 0 }}
                                                slideProps={{ height: 150, renderInfo: false }}
                                                sliderClassName="slider--unequal--small"
                                                title="Recently added to list"
                                                titleSmall={true}
                                                url={Artcloud.url.vendor.marketplace.profiles.recent.get(data.ProfileId)} />
                                        }
                                    </div>
                                </Spaced>
                                <Spaced className="spacer--bottom">
                                    <Title small={true}>
                                        <h2>Works from following</h2>
                                    </Title>
                                    {
                                        this.state.artwork.data &&
                                        this.state.artwork.data.length == 0 &&
                                        <NoResults display="No Artwork" />
                                    }
                                    <ArtworkGridContainer
                                        sizeClassName="art__container grid--3"
                                        sizingContainerId="sizing-artwork"
                                        onWaypointEnter={this.handleArtworkWaypointEnter}>
                                        {
                                            this.state.artwork.data &&
                                            this.state.artwork.data.length > 0 &&
                                            this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--3" d={d} sizingContainerId="sizing-artwork" onLikeChange={this.handleArtworkLikeChange} cols={4} />)
                                        }
                                    </ArtworkGridContainer>
                                    {
                                        this.state.artwork.loading &&
                                        <LoadingIndicator />
                                    }
                                </Spaced>
                            </React.Fragment>
                        }
                        {
                            this.props.tab== 'lists' &&
                            <React.Fragment>
                                {
                                    this.state.lists.loading &&
                                    <LoadingIndicator />
                                }
                                {
                                    this.state.lists.data &&
                                    <section className="section--mheight">
                                        {
                                            this.state.lists.data.length == 0 &&
                                            <NoResults display="No Lists" />
                                        }
                                        {
                                            this.state.lists.data.length > 0 &&
                                            <React.Fragment>
                                                <div className="container">
                                                    <div className="section__title__title--small">
                                                        <h2>{this.state.lists.data.length} List{this.state.lists.data.length != 1 ? 's' : ''}</h2>
                                                    </div>
                                                </div>
                                                <div className="lists--double">
                                                    <div className="container">
                                                        <div className="container--spaced__row">
                                                            {this.state.lists.data.map((d) => <ListCell key={d.ListId} d={d} />)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </section>
                                }
                            </React.Fragment>
                        }
                        {
                            this.props.tab== 'following' &&
                            this.props.data &&
                            <React.Fragment>
                                <div className="spacer--bottom">
                                    <ArtistsSlider
                                        id="follows"
                                        title={this.state.artistsFollowsTitle}
                                        titleSmall={true}
                                        slideProps={{ cols: 5, slider: true }}
                                        url={Artcloud.url.vendor.marketplace.profiles.follows.artists.get(data.ProfileId)}
                                        onParseResults={this.handleParseFollows}
                                    />
                                </div>
                                <div className="spacer--bottom">
                                    <GalleriesSlider
                                        config={this.galleriesSliderConfig}
                                        id="follows"
                                        slideProps={{ setWidth: false }}
                                        title={this.state.galleriesFollowsTitle}
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.profiles.follows.galleries.get(data.ProfileId)}
                                        onParseResults={this.handleParseFollows} />
                                </div>
                                <div className="spacer--bottom">
                                    <ProfilesSlider
                                        id="follows"
                                        title={this.state.profilesFollowsTitle}
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.profiles.follows.profiles.get(data.ProfileId)}
                                        onParseResults={this.handleParseFollows} />
                                </div>
                            </React.Fragment>
                        }
                        {
                            this.props.tab== 'collection' &&
                            <Spaced className="spacer--bottom">
                                {
                                    this.state.collection.data &&
                                    <React.Fragment>
                                        <Title small={true}>
                                            <h2>{this.state.collection.total} artwork{this.state.collection.total != 1 ? 's' : ''}</h2>
                                            <Arrows display="Manage collection" onClick={this.handleManageCollection} />
                                        </Title>
                                        {
                                            this.state.collection.data.length == 0 &&
                                            <div className="blank__cont blank--outline">
                                                <p className="blank__text">Start your collection with artcloud Manager, create invoices, take payments.</p>
                                                <Arrows display="Manage collection" onClick={this.handleManageCollection} />
                                                <div className="blank--outline__img">
                                                    <img src="https://artcld.com/assets/img/graphics/mockups.png" alt="" />
                                                </div>
                                            </div>
                                        }
                                    </React.Fragment>
                                }
                                <ArtworkGridContainer
                                    sizeClassName="art__container grid--3"
                                    onWaypointEnter={this.handleCollectionWaypointEnter}
                                >
                                    {this.state.collection.data &&
                                    this.state.collection.data.length > 0 &&
                                    this.state.collection.data.map((d) => (
                                        <ArtworkCell
                                        key={d.ArtId}
                                        className="grid--3"
                                        d={d}
                                        cols={4}
                                        />
                                    ))}
                                </ArtworkGridContainer>
                                {this.state.collection.loading && <LoadingIndicator />}
                            </Spaced>
                        }
                        {
                            this.state.accountModal &&
                            <Settings user={Artcloud.auth.user} onClose={this.handleEditAccountClose} />
                        }
                        {
                            this.state.listArtworkAddModal &&
                            this.state.listArtworkAddModal.visible &&
                            <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                        }
                    </Spaced>
                </Section>
            </React.Fragment>
        );
    }
}

function ProfileHeader(props) {
    const data = props.data || {};
    return (
        <div className="profile__cont header--profile">
            <div className="container">
                {
                    data.Image &&
                    <div className="profile__mark profile__mark--img">
                        <img src={data.Image.SmallUrl} alt={data.Name} />
                    </div>
                }
                <h2 className="profile__title">
                    <div className="profile__title__text m-r-1">{data.Name}</div>
                    {
                        data.MyAccount &&
                        <TextButton config={{ size: 'small', style: 'underline' }} renderAsLink={true} onClick={props.onEditAccount}>Edit account</TextButton>
                    }
                    {
                        !data.MyAccount &&
                        <FollowButton data={data} onChange={props.onFollowChange} />
                    }
                </h2>
            </div>
            <div className="container">
                {
                    data.IsVerified &&
                    <div><span className="i i--ac" /> Verified ArtCloud Account</div>
                }
            </div>
        </div>
    );
}

function ListCell(props) {
    let style;
    if (props.d.ImgSrc) {
        style = { backgroundImage: `url('${props.d.ImgSrc}')` };
    }
    return (
        <a href={`/list/${props.d.ListId}`} className="lists__cont lists--box" >
            <span className="lists--box__inner" style={style}>
                <div className="lists--box__content">
                    <h2 className="lists--box__title">{props.d.Name}</h2>
                    <div className="lists--box__info">
                        <span><strong>{props.d.ArtIds.length} artwork{props.d.ArtIds.length != 1 ? 's' : ''}</strong></span>
                        <span>{props.d.Invited} friend{props.d.Invited != 1 ? 's' : ''} invited</span>
                    </div>
                </div>
            </span>
        </a >
    );
}

function PopupTab(props) {
    return (
        <a href="#"
            className={`popup__tabs__anchor${props.active ? ' popup__tabs__anchor--active' : ''}`}
            data-tab={props.tab}
            onClick={props.onClick}>
            {props.display}
        </a>
    );
}

let _SettingsInst;
class Settings extends React.Component {
    constructor(props) {
        super(props);

        const user = props.user || {};
        this.state = {
            loading: true,
            tab: 'profile',
            ...user
        };

        this.inputConfig = {
            color: 'light',
            size: 'medium',
            style: 'outline'
        };

        this.frequencyOptions = [
            { display: 'Never', value: 0 },
            { display: 'Daily', value: 1 },
            { display: 'Weekly', value: 2 },
            { display: 'Monthly', value: 3 }
        ];
        this.typeOptions = [
            { display: 'Collector', value: 6 },
            { display: 'Artist', value: 2 },
            { display: 'Gallery', value: 3 }
        ];

        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOptionSelect = this.handleOptionSelect.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    componentDidMount() {
        _SettingsInst = true;

        const component = this;
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.sessions.current.settings.get(),
            null,
            function (responseData) {
                component.request = null;

                component.setState(responseData);
                component.setState({
                    loading: false
                });
            },
            function () {
                component.request = null;
                component.setState({
                    loading: false
                });
            }
        );
    }

    componentWillUnmount() {
        _SettingsInst = undefined;

        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    handleChange(name, value) {
        let emailAlert = this.state.emailAlert;
        if (name == 'Email' && value.length) {
            emailAlert = undefined;
        }
        this.setState({
            emailAlert: emailAlert,
            [name]: value
        });
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleOptionSelect(name, value) {
        let options;
        switch (name) {
            case 'Frequency':
                options = this.frequencyOptions;
                break;
            case 'Type':
                options = this.typeOptions;
                break;
        }
        if (!options) {
            return;
        }
        let option;
        for (let i = 0; i < options.length; i++) {
            const temp = options[i];
            if (temp.value != value) {
                continue;
            }
            option = temp;
            break;
        }
        if (!option) {
            return;
        }
        this.setState({
            [name]: {
                Name: option.display,
                Value: option.value
            }
        });
    }

    handleSubmit() {
        const component = this;
        if (!component.state.Email) {
            component.setState({
                emailAlert: true,
                tab: 'account'
            })
            return;
        }
        component.setState({
            loading: true
        });
        const errorHandler = function (jqXHR, textStatus) {
            if (!_SettingsInst) {
                return;
            }
            component.setState({
                loading: true
            });
            Artcloud.api.mktfail(jqXHR, textStatus);
        }
        let postData = {
            Bio: component.state.Bio,
            AddressLineOne: component.state.AddressLineOne,
            AddressLineTwo: component.state.AddressLineTwo,
            City: component.state.City,
            Zip: component.state.Zip,
            Country: component.state.Country
        };
        Artcloud.api.post(
            Artcloud.url.vendor.sessions.current.settings.profile.post(),
            postData,
            function () {
                postData = {
                    Email: component.state.Email,
                    Password: component.state.Password,
                    Type: component.state.Type ? component.state.Type.Value : undefined
                }
                Artcloud.api.post(
                    Artcloud.url.vendor.sessions.current.settings.account.post(),
                    postData,
                    function () {
                        postData = { Frequency: component.state.Frequency ? component.state.Frequency.Value : undefined }
                        Artcloud.api.post(
                            Artcloud.url.vendor.sessions.current.settings.notifications.post(),
                            postData,
                            function () {
                                if (component.props.onClose) {
                                    component.props.onClose();
                                }
                                Artcloud.mkt.modals.success('Your profile has been updated.');
                            },
                            errorHandler
                        );
                    },
                    errorHandler
                );
            },
            errorHandler
        );
    }

    handleTabClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            tab: event.currentTarget.dataset.tab
        });
    }

    render() {
        return (
            <React.Fragment>
                <Popup className="popup--account" type='popup' onClose={this.handleClose}>
                    <h2 className="popup__title">Edit Settings</h2>
                    <div className="popup__tabs">
                        <PopupTab
                            active={this.props.tab== 'profile'}
                            display="Profile"
                            tab="profile"
                            onClick={this.handleTabClick} />
                        <PopupTab
                            active={this.props.tab== 'account'}
                            display="Account"
                            tab="account"
                            onClick={this.handleTabClick} />
                        <PopupTab
                            active={this.props.tab== 'notifications'}
                            display="Notifications"
                            tab="notifications"
                            onClick={this.handleTabClick} />
                    </div>
                    <div className="popup__tabs__content popup__tabs__content--active form__inner popup__inner form__spacer">
                        {
                            this.props.tab== 'profile' &&
                            <React.Fragment>
                                <FormLabel display="Bio" />
                                <Input
                                    config={{ color: 'light', size: 'small', style: 'outline' }}
                                    name="Bio"
                                    textArea={true}
                                    type="text"
                                    value={this.state.Bio}
                                    onChange={this.handleChange} />
                                <FormLabel display="Contact information" />
                                <div className="input--double">
                                    <Input
                                        config={this.inputConfig}
                                        name="AddressLineOne"
                                        placeholder="Address Line 1"
                                        type="text"
                                        value={this.state.AddressLineOne}
                                        onChange={this.handleChange} />
                                    <Input
                                        config={this.inputConfig}
                                        name="AddressLineTwo"
                                        placeholder="Address Line 2"
                                        type="text"
                                        value={this.state.AddressLineTwo}
                                        onChange={this.handleChange} />
                                </div>
                                <div className="input--triple">
                                    <Input
                                        config={this.inputConfig}
                                        name="City"
                                        placeholder="City"
                                        type="text"
                                        value={this.state.City}
                                        onChange={this.handleChange} />
                                    <Input
                                        config={this.inputConfig}
                                        name="Zip"
                                        placeholder="Zip Code"
                                        type="text"
                                        value={this.state.Zip}
                                        onChange={this.handleChange} />
                                    <Input
                                        config={this.inputConfig}
                                        name="Country"
                                        placeholder="Country"
                                        type="text"
                                        value={this.state.Country}
                                        onChange={this.handleChange} />
                                </div>
                            </React.Fragment>
                        }
                        {
                            this.props.tab== 'account' &&
                            <React.Fragment>
                                <FormLabel display="Email" />
                                <Input
                                    autoComplete="off"
                                    className={this.state.emailAlert ? '' : undefined}
                                    config={this.state.emailAlert ? { ...this.inputConfig, alert: 'required' } : this.inputConfig}
                                    name="Email"
                                    placeholder="Email Address"
                                    type="email"
                                    value={this.state.Email}
                                    onChange={this.handleChange} />
                                <FormLabel display="Password (leave black if not changing)" />
                                <Input
                                    config={this.inputConfig}
                                    name="Password"
                                    placeholder="Password"
                                    type="password"
                                    value={this.state.Password}
                                    onChange={this.handleChange} />
                                <FormLabel display="Account Type" />
                                <Select
                                    display={this.state.Type && this.state.Type.Name}
                                    name="Type"
                                    options={this.typeOptions}
                                    onOptionSelect={this.handleOptionSelect} />
                            </React.Fragment>
                        }
                        {
                            this.props.tab== 'notifications' &&
                            <React.Fragment>
                                <FormLabel display="artcloud Suggestions" />
                                <Select
                                    display={this.state.Frequency && this.state.Frequency.Name}
                                    name="Frequency"
                                    options={this.frequencyOptions}
                                    onOptionSelect={this.handleOptionSelect} />
                            </React.Fragment>
                        }
                        <Arrows
                            config={{ color: 'light' }}
                            display="Update Profile"
                            form={true}
                            onClick={this.handleSubmit} />
                    </div>
                </Popup>
                {
                    this.state.loading &&
                    <LoadingFull style={{ backgroundColor: '#222' }} />
                }
            </React.Fragment>
        );
    }
}

const Profile = forResource(_Profile, Artcloud.url.vendor.marketplace.profiles.get);
const ProfileSection = forResource(_Profile, Artcloud.url.vendor.marketplace.profiles.get, 1);
export {
    Profile,
    ProfileSection
};